import LegalPage from './LegalPage';

export default function PrivacyPolicy() {
  return (
    <LegalPage
      pageKey="privacy"
      testId="privacy-policy"
      extraFooterLinks={[
        { to: '/terms', labelKey: 'terms' },
        { to: '/sms-compliance', labelKey: 'smsCompliance' },
      ]}
    />
  );
}
